import { useQueryClient } from "@tanstack/react-query";

import { MATERIALS_KEYS } from "@/config/services/queryKeys";

export const useRefetchMaterialsList = () => {
  const queryClient = useQueryClient();

  return {
    refetchList: () => {
      queryClient.invalidateQueries({ queryKey: [MATERIALS_KEYS.RECORDS], type: "all" });
    },
  };
};
